import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CmsLinkComponent, CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'app-cookie-policy-social',
    templateUrl: './cookie-policy-social.component.html',
    styleUrl: './cookie-policy-social.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CookiePolicySocialComponent {
  public componentData: CmsLinkComponent;

  constructor(public component: CmsComponentData<CmsLinkComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });

  }
}
